import React from 'react';
import {Text, TextMessage} from 'components/tt-forms/common';
import moment from 'moment';
import { ShowIf } from 'components/utils';

class BlockBaoCaoKQTTXM extends React.Component {
  render() {
    let donInfo = this.props.donInfo ? this.props.donInfo : {};
    let thongTinGQD = this.props.thongTinGQD ? this.props.thongTinGQD : {};
    let _noiDung = thongTinGQD.noiDung ? thongTinGQD.noiDung : '';
    let _ngayBaoCaoKQ = thongTinGQD.ngayTraBaoCaoTTXM ? moment(thongTinGQD.ngayTraBaoCaoTTXM).format('DD/MM/YYYY') : '';
    let _tgBaoCaoKQ = thongTinGQD.ngayHetHanTTXM ? moment(thongTinGQD.ngayHetHanTTXM).format('DD/MM/YYYY') : '';
    if (donInfo.laTTXMLai) {
      _ngayBaoCaoKQ = donInfo.ngayTraBaoCaoTTXMLanDau ? moment(donInfo.ngayTraBaoCaoTTXMLanDau).format('DD/MM/YYYY') : '';
      _tgBaoCaoKQ = donInfo.ngayHetHanTTXMLanDau ? moment(donInfo.ngayHetHanTTXMLanDau).format('DD/MM/YYYY') : '';
      _noiDung = thongTinGQD.noiDungTraBaoCaoTTXMLan1 || '';
    }
    let userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
    let showKQTTXMLai = false;

    if (donInfo.trangThaiDonInfo.length) {
      donInfo.trangThaiDonInfo.map(item => {
        if (userInfo.donViId == item.donViId && item.ketQuaType != 'DANG_TTXM') {
          showKQTTXMLai = true;
        }
      });
    }
    let lb1 = donInfo.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? 'xác minh đề xuất:' : 'TTXM:';
    let lb2 = donInfo.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? ' đề xuất' : '';
    return (
      <div className={!thongTinGQD.donViThamTraXacMinhInfo ? 'hidden' : ''}>
        <h3 className="txt-upper title-14 mt0 mb15 pl5 pr5">Báo cáo kết quả xác minh{lb2}</h3>
        <div className="col-100 mb10 no-gutter">
          <Text className="col-25 mb10" label={'Đơn vị '+lb1} value={thongTinGQD.donViThamTraXacMinhInfo ? thongTinGQD.donViThamTraXacMinhInfo.ten : ''}/>
          <Text className="col-25 mb10" red={true} label="Thời gian báo cáo kết quả:" value={_tgBaoCaoKQ}/>
          <Text className="col-25 mb10" label="Ngày báo cáo kết quả:" value={_ngayBaoCaoKQ}/>
          <TextMessage className='col-100' label='Ý kiến xử lý:' value={_noiDung}/>
        </div>
        <ShowIf condition={donInfo.laTTXMLai == true && showKQTTXMLai}>
          <div className="col-100 no-gutter pt10 pb10">
            <span className="line-border"></span>
          </div>
          <h3 className="txt-upper title-14 mt0 mb15 pl5 pr5">Báo cáo kết quả xác minh{lb2} lại</h3>
          <div className="col-100 mb10 no-gutter">
            <Text className="col-25 mb10" label={'Đơn vị '+lb1} value={thongTinGQD.donViThamTraXacMinhInfo ? thongTinGQD.donViThamTraXacMinhInfo.ten : ''}/>
            <Text className="col-25 mb10" red={true} label="Thời gian báo cáo kết quả:" value={thongTinGQD.ngayHetHanTTXM ? moment(thongTinGQD.ngayHetHanTTXM).format('DD/MM/YYYY') : ''}/>
            <Text className="col-25 mb10" label="Ngày báo cáo kết quả:" value={thongTinGQD.ngayTraBaoCaoTTXM ? moment(thongTinGQD.ngayTraBaoCaoTTXM).format('DD/MM/YYYY') : ''}/>
            <TextMessage className='col-100' label='Ý kiến xử lý:' value={thongTinGQD.noiDungTraBaoCaoTTXMLan2 || ''}/>
          </div>
        </ShowIf>
      </div>
    );
  }
}

BlockBaoCaoKQTTXM.defaultProps = {
  donInfo: {}
}

export default BlockBaoCaoKQTTXM;


// WEBPACK FOOTER //
// ./src/components/modules/giai-quyet-don/subView/BlockBaoCaoKQTTXM.jsx